// libraries.
import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";

// components.
import { VIMChangeCard } from "./VIMChangeCard";
import { VIMPredictionCard } from "./VIMPredictionCard";
import { PriceOptionsDropdown } from "./PriceOptionsDropdown";

// slices.
import {
  ModelResult,
  PredictionPublicationPrice,
} from "../interfaces/interfaces";
import {
  resetVIMMetrics,
  setSelectedOption,
  setSuggestionOption,
  setVIMMetrics,
} from "../slices/vim.slice";
import { getValidOptimalPrice } from "../utils/getOptimalPrice";

// styles.
import { WrapperVIM } from "../styles";

interface Props {
  dataVim: ModelResult;
  onClose: () => void;
  show: boolean;
}

export const VIMModal = ({ show, onClose, dataVim }: Props) => {
  const dispatch = useDispatch();

  const [optionSelected, setOptionSelected] =
    useState<PredictionPublicationPrice | null>(null);

  const optimalPrice = getValidOptimalPrice(dataVim.recomendacion);
  const suggestionOption = dataVim.predicciones.find(
    (option) => option.precio_nuevo === optimalPrice,
  );

  const vimMetricsPayload = {
    clicks_15_dias_antes: dataVim.clicks_15_dias_antes,
    precio_actual_de_publicacion: dataVim.precio_actual_de_publicacion,
    precio_recomendado: dataVim.recomendacion.precio_recomendado,
    visitas_15_dias_antes: dataVim.visitas_15_dias_antes,
    visitas_para_promesa: dataVim.visitas_para_promesa,
  };

  const submitOption = (
    selected: PredictionPublicationPrice | null,
    suggestion: PredictionPublicationPrice | null,
  ) => {
    dispatch(setSelectedOption(selected));
    dispatch(setSuggestionOption(suggestion));
    dispatch(setVIMMetrics(vimMetricsPayload));
    onClose();
  };

  const handleSubmitSuggestion = () => {
    if (suggestionOption) {
      submitOption(null, suggestionOption);
    }
  };

  const handleSubmit = () => {
    if (optionSelected) {
      submitOption(optionSelected, null);
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => {}}
      size={optionSelected ? "lg" : undefined}
      centered
    >
      <WrapperVIM>
        <Modal.Header>
          <Modal.Title>Valor Inteligente del Mercado</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-row gap-2 justify-content-between">
            <div className="d-flex flex-column gap-2 border rounded p-3 w-100 justify-content-between">
              <PriceOptionsDropdown
                onSelect={(option) => setOptionSelected(option)}
                options={dataVim.predicciones}
                selectedOption={optionSelected}
                optimalPrice={optimalPrice}
                dataVim={dataVim}
              />
              {optionSelected && (
                <VIMChangeCard data={optionSelected} options={dataVim} />
              )}
              <div className="d-flex flex-row gap-1 justify-content-between">
                <Button
                  className="btn-habi w-100"
                  disabled={!optionSelected}
                  onClick={handleSubmit}
                  style={{ marginTop: "1rem" }}
                >
                  Guardar cambio
                </Button>
                <Button
                  className="btn-habi-suggestion w-100"
                  disabled={
                    !suggestionOption ||
                    optionSelected?.precio_nuevo !==
                      suggestionOption.precio_nuevo
                  }
                  onClick={handleSubmitSuggestion}
                  style={{ marginTop: "1rem" }}
                >
                  Guardar sugerencia
                </Button>
              </div>
            </div>
            {optionSelected && (
              <div className="w-100 d-flex">
                <VIMPredictionCard data={optionSelected} />
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="p-1">
          <Button
            className="btn-habi-white"
            onClick={() => {
              submitOption(null, null);
              setOptionSelected(null);
              dispatch(resetVIMMetrics());
              onClose();
            }}
          >
            Cambio manual
          </Button>
        </Modal.Footer>
      </WrapperVIM>
    </Modal>
  );
};
